 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g wall-type-4 [height]="height()"></g>
        
        <g roof-type-7/>
        <g outline />
        <g window-type-3 [height]="height()"/>

</svg>